var render = function render(_c,_vm){return _c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.props.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }